<template>
  <f7-popup id="popup-calendar" class="popup-calendar">
    <f7-view>
      <f7-page>
        <Calendar @push="push" @pull="pull"></Calendar>
      </f7-page>
    </f7-view>
  </f7-popup>
</template>

<script>
import moment from 'moment';
import apiRequest from '@/js/helpers/apiRequest.js';

import Calendar from '@/components/Calendar.vue';

export default {
  name: 'PopupCalendar',

  components: {
    Calendar
  },

  methods: {
    // push to server
    push(spans) {
      const normalizeSpans = Object.entries(spans).map(([key, value]) => ({
        [key]:
          value &&
          Array.from(
            value.map(times => {
              const result = times.split(' - ');
              return {
                start: `${key} ${result[0]}`,
                end: `${key} ${result[1]}`
              };
            })
          )
      }));

      const dates = Object.getOwnPropertyNames(spans);
      const body = new FormData();

      normalizeSpans.forEach(val => body.append('spans[]', JSON.stringify(val)));
      body.append('start', moment(dates[0]).format('DD-MM-YYYY'));
      body.append('end', moment(dates[dates.length - 1]).format('DD-MM-YYYY'));
      body.append('tz', new Date().getTimezoneOffset() / 60);

      apiRequest('spans', 'POST', body, true);
    },

    // pull from server
    async pull(from_date, to_date, resolve) {
      try {
        const result = await apiRequest(
          `spans?start=${from_date.format('DD-MM-YYYY')}&end=${to_date.format(
            'DD-MM-YYYY'
          )}&tz=${new Date().getTimezoneOffset() / 60}`,
          'GET',
          null,
          true
        );

        resolve(result.success);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="less">
#popup-calendar.popup:not(.popup-tablet-fullscreen) {
  @media (min-height: 630px) and (min-width: 630px) {
    --f7-popup-tablet-width: 501px;
    --f7-popup-tablet-height: 565px;
  }
}

// #popup-calendar {
//   .page-content {
//   }
// }
</style>
